export const PAGE_NAMES = {
  HOME: "Home",
  ABOUT: "About",
  CLIENTS: "Clients",
  TECH: "Tech",
  SHOWCASE: "Showcase",
  DEMOS: "Demos",
  CONTACT: "Contact",
};

export const NAV_STATES = {
  SHOW: "show",
  HIDE: "hide",
};

export const QR_TEXT = {
  PLACEHOLDER: "Type to update...",
};
